module.exports = __webpack_public_path__ + "media/alarm_tone.54aedc83.mp3";